import React from 'react';

import BitbucketBranchesIcon from '@atlaskit/icon/core/branch';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { LoadableAfterPaint } from '@confluence/loadable';
import { isBranchDeployFn } from '@confluence/atlassian-internal-help-items';

const BranchDeployLogoLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BranchDeployLogo" */ './BranchDeployLogo.tsx'))
			.BranchDeployLogo,
	loading: () => <BitbucketBranchesIcon label="Loading..." />,
});

const FeatureFlagLogoLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FeatureFlagLogo" */ './FeatureFlagLogo.tsx'))
			.FeatureFlagLogo,
});

export const DeveloperButtons = ({
	isAtlassianStaff = false,
}: {
	isAtlassianStaff?: boolean | undefined;
}): React.JSX.Element => {
	const isBranchDeploy = isBranchDeployFn();
	const featureGateOverrides = FeatureGates.getOverrides();
	const hasOverrides =
		Object.keys(featureGateOverrides.gates).length > 0 ||
		Object.keys(featureGateOverrides.configs).length > 0;

	return (
		<>
			{isBranchDeploy && <BranchDeployLogoLoader />}
			{isAtlassianStaff && hasOverrides && (
				<FeatureFlagLogoLoader featureGateOverrides={featureGateOverrides} />
			)}
		</>
	);
};
